import { useMap } from "react-leaflet";
import L from "leaflet";
import { useEffect } from "react";

function GridOverlay() {
    const map = useMap();

    useEffect(() => {
        // Store references so we can remove them on unmount
        const lines = [];
        const markers = [];

        // 1) Horizontal lines (rows)
        for (let row = 0; row <= 10; row++) {
            const y = row * 200;
            // Draw a line from (y, 0) to (y, 2000)
            const line = L.polyline(
                [
                    [y, 0],
                    [y, 2000],
                ],
                { color: "white", weight: 1 }
            ).addTo(map);
            lines.push(line);
        }

        // 2) Vertical lines (columns)
        for (let col = 0; col <= 10; col++) {
            const x = col * 200;
            // Draw a line from (0, x) to (2000, x)
            const line = L.polyline(
                [
                    [0, x],
                    [2000, x],
                ],
                { color: "white", weight: 1 }
            ).addTo(map);
            lines.push(line);
        }

        // 3) Row labels: 1..10 (placed along the left edge)
        for (let row = 1; row <= 10; row++) {
            const labelY = (row - 0.5) * 200; // place label in the center of the cell
            // Slightly to the left of x=0 so it’s visible
            const marker = L.marker([labelY, -30], {
                interactive: false,
                icon: L.divIcon({
                    className: "grid-label",
                    html: `<div style="color: white;">${row}</div>`,
                }),
            }).addTo(map);
            markers.push(marker);
        }

        // 4) Column labels: A..J (placed along the top edge)
        for (let col = 1; col <= 10; col++) {
            const labelX = (col - 0.5) * 200;       // center of each 200m column
            const letter = String.fromCharCode(64 + col); // 1->A, 2->B, etc.

            const marker = L.marker([-30, labelX], {
                interactive: false,
                icon: L.divIcon({
                    className: "grid-label",
                    html: `<div style="color: white;">${letter}</div>`,
                }),
            }).addTo(map);
            markers.push(marker);
        }


        // Cleanup: remove lines & markers on unmount
        return () => {
            lines.forEach((line) => map.removeLayer(line));
            markers.forEach((marker) => map.removeLayer(marker));
        };
    }, [map]);

    return null; // no actual DOM element
}

export default GridOverlay;
